import styled from '@emotion/styled';
import {mixinSVGIcon} from 'webapp-lib/styling';

import {StyledAction} from './InputAction/styles';

export interface BaseProps {
  success?: boolean;
  error?: boolean;
}

interface BorderColorArguments {
  error?: boolean;
  success?: boolean;
}

export function borderColor(args?: {
  focused?: boolean;
  hovered?: boolean;
}): (arg0: BorderColorArguments) => string {
  const {focused} = args || {focused: false, hovered: false};

  return ({error, success}: BorderColorArguments): string =>
    success
      ? 'var(--color-alerts-success)'
      : error
        ? 'var(--color-alerts-error)'
        : focused
          ? 'var(--color-core-keyboardfocus)'
          : 'var(--color-core-dark-grey)';
}

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export const BaseInput = styled('div', {
  shouldForwardProp: (prop: string) => !['error', 'success'].includes(prop),
})<BaseProps>`
  outline: none;
  border-radius: 2px;
  border: var(--regular-border-width) solid ${borderColor()};
  min-width: 32px;
  min-height: 40px;
  font-weight: var(--font-weight-thin);
  font-size: var(--font-size-default);
  color: var(--color-core-black);

  :hover {
    border: var(--regular-border-width) solid ${borderColor({hovered: true})};
  }

  :disabled {
    background-color: var(--color-core-grey-light);
    color: var(--input-color-disabled);

    :hover {
      box-shadow: none;
      border: var(--regular-border-width) solid grey;
    }
  }

  :focus-within,
  :focus {
    box-shadow: 0px 0 0px var(--focus-border-width)
      ${borderColor({focused: true})};
    border-radius: var(--focus-border-radius);
  }
`;

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export const Wrapper = styled.div<BaseProps>`
  display: flex;
  height: min-content;
  flex-direction: column;
  margin-bottom: var(--gutter-big);
  margin-top: var(--gutter-big);

  :first-of-type {
    margin-top: var(--gutter-medium);
  }
`;

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export const Label = styled.label`
  float: left;
  font-weight: var(--font-weight-thin);
  font-size: var(--font-size-default);
  color: var(--color-core-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;

  svg {
    fill: var(--color-state-active);
  }
`;

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export const InfoIconWrapper = styled.div`
  margin: 0 var(--gutter-tiny);
  svg {
    ${mixinSVGIcon}
  }
`;

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export const LeftAssistiveText = styled.span`
  overflow-wrap: anywhere;
`;

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export const TopSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
  height: 19px;
  margin-top: var(--negative-form-item-spacing);

  button {
    border: unset;
    background-color: unset;
    padding: unset;
    cursor: pointer;
  }
`;

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
interface TextAreaProps {
  success: boolean;
  error: boolean;
}

/**
 * @deprecated Will be removed in LEXIAN-4297. Please use the components from webapp-lib instead.
 */
export const BottomSection = styled.div<TextAreaProps>`
  font-size: var(--font-size-tiny);
  font-weight: var(--font-weight-thin);
  min-height: 11px;
  margin-top: 5px;
  margin-bottom: ${({children}): string =>
    children ? 'calc(var(--gutter-tiny) * -1)' : 'calc(var(--gutter) * -1)'};
  color: ${({success, error}): string =>
    success
      ? 'var(--color-alerts-success)'
      : error
        ? 'var(--color-alerts-error)'
        : 'var(--color-core-black)'};

  ${StyledAction} {
    cursor: pointer;
    float: right;
    padding: 0;
    margin-left: var(--gutter);
    border: none;
    color: var(--color-core-link);
    background-color: unset;
    font-size: var(--font-size-tiny);
  }
`;
